var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steer-bar"},[_c('div',[_c('h3',[_vm._v("Monthly Income")]),_c('input')])])}]

export { render, staticRenderFns }